/* YUMIKA, 2 nov. 2026 (Yumika : « ok transmets », maquette, point 4 ; Clarity : 2 à 4 % des visites ont une erreur JavaScript des carrousels slick « slidesToShow »).
   Chargé juste après vendor.js (qui contient slick) et avant theme.js : rend les carrousels tolérants.
   1) Un ordre donné à un carrousel pas encore prêt (ex. slickGoTo, setPosition) est ignoré au lieu de planter.
   2) Les fonctions internes de slick ne plantent plus quand un carrousel a été défait (redimensionnement, changement de coloris) : l'erreur
      « slidesToShow » est absorbée, les autres erreurs restent visibles.
   Retour arrière : retirer la ligne yk-slick-garde.js de snippets/header-js.liquid. */
(function(){
  var $ = window.jQuery;
  if(!$ || !$.fn || !$.fn.slick || $.fn.slick.ykGarde) return;
  var orig = $.fn.slick;
  function guard(proto){
    if(!proto || proto.ykGarde) return;
    Object.keys(proto).forEach(function(k){
      var fn = proto[k];
      if(typeof fn !== 'function' || k === 'init' || k === 'constructor') return;
      proto[k] = function(){
        if(!this || !this.options) return;
        try{ return fn.apply(this, arguments); }
        catch(e){ if(e && /slidesToShow/.test(String(e.message))) return; throw e; }
      };
    });
    proto.ykGarde = true;
  }
  try{
    var tmp = $('<div><div></div><div></div></div>');
    orig.call(tmp, { arrows: false, dots: false, accessibility: false });
    if(tmp[0].slick){ guard(Object.getPrototypeOf(tmp[0].slick)); orig.call(tmp, 'unslick'); }
  }catch(e){}
  var wrapped = function(){
    var a = arguments;
    if(typeof a[0] === 'string'){
      var ready = this.filter(function(){ return !!this.slick; });
      if(!ready.length) return this;
      return orig.apply(ready, a);
    }
    return orig.apply(this, a);
  };
  wrapped.ykGarde = true;
  $.fn.slick = wrapped;
})();
